import { render, staticRenderFns } from "./LogDetail.vue?vue&type=template&id=2a6b9aaa&scoped=true&"
import script from "./LogDetail.vue?vue&type=script&lang=js&"
export * from "./LogDetail.vue?vue&type=script&lang=js&"
import style0 from "./LogDetail.vue?vue&type=style&index=0&id=2a6b9aaa&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6b9aaa",
  null
  
)

export default component.exports